import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderDelete: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderDelete"><Path fillRule="evenodd" clipRule="evenodd" d="M2.00015 3H10.5353L12.5353 6H22.0002V20H10.2433L11.2432 19L9.24324 17L11.2432 15L7.0006 10.7574L5.0006 12.7574L3.0006 10.7574L2.00015 11.7578V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8.41436 15L6.41436 17L8.41436 19L7.00015 20.4142L5.00015 18.4142L3.00015 20.4142L1.58594 19L3.58594 17L1.58594 15L3.00015 13.5858L5.00015 15.5858L7.00015 13.5858L8.41436 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderDelete;
